import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import MeetingModal, { MODE } from '@/models/meeting';

import 'swiper/swiper.less';
import BarrageModel from '@/models/barrage';
import s from './index.less';
import ViewBox, { viewBoxType } from '../../ViewBox';
import { focused } from '@/models';
import { motion, useAnimationControls } from 'framer-motion';
import classnames from 'classnames';

interface ViewPanelProps {
  meeting?: MeetingModal;
  barrage?: BarrageModel;
}

const FocusedView: React.FC<ViewPanelProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    user: store.user,
    barrage: store.barrage,
  };
})(
  observer((props: ViewPanelProps) => {
    const { meeting } = props;
    const controlsContainer = useAnimationControls();
    const controlsTop = useAnimationControls();
    const controlsBottom = useAnimationControls();
    const [screen, setScreen] = useState<{ yxUid: string; type: viewBoxType }>({
      yxUid: '',
      type: viewBoxType.screen,
    });

    const [speak, setSpeak] = useState<{ yxUid: string; type: viewBoxType }>({
      yxUid: '',
      type: viewBoxType.screen,
    });

    useEffect(() => {
      if (
        focused?.focusedYuxid &&
        (meeting?.screenUserInfo?.yxUidStr || meeting?.whiteboardAuth || meeting?.codeEditorEnabled)
      ) {
        setScreen({
          yxUid: focused?.focusedYuxid,
          type: viewBoxType.video,
        });
      } else if (focused?.focusedYuxid) {
        setScreen({
          yxUid: '',
          type: viewBoxType.screen,
        });
      }
    }, [
      focused?.focusedYuxid,
      meeting?.screenUserInfo?.yxUidStr,
      meeting?.whiteboardAuth,
      meeting?.codeEditorEnabled,
    ]);

    const startAnimation = async () => {
      // if (!speak?.yxUid) {
      //   return;
      // }
      await controlsBottom?.set({ visibility: 'visible' });
      await controlsContainer?.start({ y: 0 });
    };

    const endAnimation = async () => {
      await controlsContainer?.start({ y: 90 });
      await controlsBottom?.set({ visibility: 'hidden' });
      setSpeak({
        yxUid: '',
        type: viewBoxType.video,
      });
    };

    useEffect(() => {
      if (
        meeting?.speakerYxUid &&
        meeting?.speakerYxUid !== meeting?.screenUserInfo?.yxUidStr &&
        meeting?.speakerYxUid !== focused?.focusedYuxid &&
        meeting?.speakerName
      ) {
        setSpeak({
          yxUid: String(meeting?.speakerYxUid),
          type: viewBoxType.video,
        });
        startAnimation();
      } else {
        endAnimation();
      }
    }, [
      meeting?.speakerYxUid,
      meeting?.screenUserInfo?.yxUidStr,
      focused?.focusedYuxid,
      meeting?.speakerName,
    ]);

    return (
      <div className={s.focusedView}>
        <motion.div
          variants={{
            begin: { height: screen?.yxUid ? 181 : 90, visibility: 'visible' },
          }}
          style={{ height: screen?.yxUid ? 181 : 90, visibility: 'visible', y: 90, width: 160 }}
          transition={{ duration: 0.3 }}
          animate={controlsContainer}
          className={classnames(s.motion, screen?.yxUid && speak?.yxUid ? s.boxWrapper : '')}
        >
          {screen?.yxUid && (
            <motion.div
              className={classnames(s.viewbox, screen?.yxUid && !speak.yxUid ? s.border : '')}
              animate={controlsTop}
              id="screen"
            >
              <ViewBox
                key={screen?.yxUid + speak?.type}
                yxuid={screen?.yxUid}
                className={s.focusedBox}
                type={screen.type}
                showTalking={false}
              />
            </motion.div>
          )}

          <motion.div
            id="speak"
            className={classnames(s.viewbox, !screen?.yxUid && speak.yxUid ? s.speakBorder : '')}
            animate={controlsBottom}
            style={{ visibility: speak?.yxUid ? 'visible' : 'hidden' }}
          >
            <ViewBox
              key={speak?.yxUid + speak?.type}
              className={s.focusedBox}
              yxuid={speak?.yxUid}
              type={speak.type}
            />
          </motion.div>
        </motion.div>
      </div>
    );
  })
);
export default FocusedView;
